import {
  PlayerColor, TokenState, TokenPosition, PlayerState,
  DiceValue, Move, TOKENS_PER_PLAYER,
} from './types';
import { RuleEngine } from './RuleEngine';

export class TokenController {
  private _ruleEngine: RuleEngine;

  constructor(ruleEngine: RuleEngine) {
    this._ruleEngine = ruleEngine;
  }

  createInitialTokens(): TokenPosition[] {
    return Array.from({ length: TOKENS_PER_PLAYER }, () => ({
      state: TokenState.HOME,
      pathIndex: -1,
      stretchIndex: -1,
    }));
  }

  executeMove(
    playerIndex: number,
    tokenIndex: number,
    diceValue: DiceValue,
    players: PlayerState[],
  ): Move {
    const player = players[playerIndex];
    const token = player.tokens[tokenIndex];
    const newPos = this._ruleEngine.calculateNewPosition(token, diceValue, player.config.color);

    const capturedPlayer = this._ruleEngine.checkCapture(newPos, player.config.color, players);

    if (capturedPlayer !== null) {
      // Eat EVERY opponent goti standing on that cell — stacks included.
      for (let t = 0; t < TOKENS_PER_PLAYER; t++) {
        const other = players[capturedPlayer].tokens[t];
        if (other.state === TokenState.ON_PATH && other.pathIndex === newPos.pathIndex) {
          players[capturedPlayer].tokens[t] = this._ruleEngine.sendTokenHome(other);
        }
      }
    }

    const wasFinished = token.state !== TokenState.FINISHED && newPos.state === TokenState.FINISHED;

    player.tokens[tokenIndex] = newPos;
    if (wasFinished) {
      player.finishedCount++;
    }

    return {
      playerIndex,
      tokenIndex,
      from: token,
      to: newPos,
      isCapture: capturedPlayer !== null,
      isFinished: wasFinished,
      diceValue,
    };
  }
}
